'use strict';
angular.module('app').directive('appTheme', function (theme)
{
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            scope.$watch(function()
            {
                return theme.current;
            }, function()
            {
                attrs.$set('href', theme.getUrl());
            });
        }
    };
});
